export default __webpack_public_path__ + "static/media/Accessories.e119e20c.svg";